module.exports = __webpack_public_path__ + "static/media/image9.ef78c891.png";